import {WorkforceTeamCreationState} from '../../../services/payroll-workforce/workforce-team-creation.state';
import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {WorkforceBrowseState, WorkforceFilter} from '../../../services/payroll-workforce/workforce-browse.state';

@Component({
    selector: 'app-payroll-workforce-browse',
    templateUrl: './payroll-workforce-browse.component.html',
    styleUrls: ['./payroll-workforce-browse.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollWorkforceBrowseComponent {
  @Input() state!: WorkforceBrowseState;
  @Input() selectionOnly = false;
  @Input() memberEditing = false;
  @Input() disabled = false;
  @Input() creation!: WorkforceTeamCreationState;
  @Input() matching: import('../../../services/payroll-workforce/workforce-team-criteria.state').MatchingSelection | null = null;
  @Output() matchingChange = new EventEmitter<import('../../../services/payroll-workforce/workforce-team-criteria.state').MatchingSelection | null>();
  @Output() createTeam = new EventEmitter<void>();
  get creating(): boolean {
    const progress = this.creation?.progress;
    return this.disabled || !!this.creation?.busy || !!progress && !['complete', 'closed'].includes(progress.phase);
  }
  @Input() matchingMode = false;
  get optionField(): WorkforceFilter { return this.state.optionField; }
  set optionField(field: WorkforceFilter) { this.state.optionField = field; }
  get optionPrefix(): string { return this.state.optionPrefix; }
  set optionPrefix(prefix: string) { this.state.optionPrefix = prefix; }
  labels: Record<string, string> = {department: 'Department', location: 'Location', division: 'Division', jobTitle: 'Job title'};
  apply(): void { if (!this.creating) { void this.state.setQuery(this.state.query); } }
  choose(value: string): void {
    if (this.creating || !this.state.canChooseOption(value)) { return; }
    this.state.query[this.optionField] = value; this.apply();
  }
  clear(field: string): void { if (!this.creating) { delete this.state.query[field]; this.apply(); } }
  options(more = false): void { if (!this.creating) { void this.state.loadOptions(this.optionField, this.optionPrefix, more); } }
  optionFieldChanged(): void { this.options(); }
  membershipReason(reason: string | null | undefined): string {
    const labels: Record<string, string> = {
      member_protected: 'Protected member or removal already in progress.',
      member_previously_removed: 'Previously removed; re-adding is unavailable.',
      identity_conflict: 'Account match is ambiguous.',
      preflight_blocked: 'Account match could not be verified.',
      primary_email_required: 'A primary email is required.',
      projection_unavailable: 'Employee information is incomplete.',
      employee_ineligible: 'Not eligible for selection.'};
    return labels[reason || ''] || 'Unavailable for selection.';
  }
  trackRow(_index: number, row: {employeeKey: string}): string { return row.employeeKey; }
  clearFilters(): void {
    if (this.creating) { return; }
    this.state.filterFields.forEach(field => delete this.state.query[field]);
    this.state.query.search = ''; this.apply();
  }
}
